import React, { ReactElement } from "react";
import { description, label, widget } from "../utils";
import { FieldTemplateProps } from "@rjsf/utils";
import PolarisFormField, {
  FormFieldProps
} from "@amzn/awsui-components-react-v3/polaris/form-field";

export default function FormField(
  props: FieldTemplateProps & FormFieldProps
): ReactElement {
  const _widget = widget(props);
  const useSideLabels =
    props.schema.type === "boolean" &&
    _widget !== "radio" &&
    _widget !== "select";
  const _label = label(props);

  return (
    <PolarisFormField
      controlId={props.id}
      label={
        // Show label next to the checkbox control, not in the FormField
        useSideLabels ? null : _label
      }
      description={
        // Show description next to the checkbox control, not in the FormField
        useSideLabels ? null : description(props)
      }
      errorText={
        // Errors are of the form `"is a required property"`. Therefore,
        // "pretty print" the message with label.
        // https://react-jsonschema-form.readthedocs.io/en/latest/usage/validation/#custom-error-messages
        props.rawErrors && `${_label} ${props.rawErrors.join(" and ")}`
      }
      constraintText={props.rawHelp} // Help string originates in UI schema
    >
      {props.children}
    </PolarisFormField>
  );
}
